module.exports = __webpack_public_path__ + "img/snapchat.c8db8d52.svg";